import * as L from 'leaflet';

export default class ThingEntity {

    public readonly latitude: number;
    public readonly longitude: number;
    public readonly creationTime: number;
    public readonly marker: L.CircleMarker;
    public readonly value: number;

    constructor(latitude: number, longitude: number, value: number) {
        this.latitude = latitude;
        this.longitude = longitude;
        this.value = value;
        this.marker = L.circleMarker([this.latitude, this.longitude], {
            weight: 3,
            color: 'white',
            fillColor: 'white',
            fillOpacity: 1,
            radius: 24,
        });
        this.creationTime = new Date().getTime() / 1000;
    }
}
